export const MAP_REQUESTED_SERVICE_SUCCESS = 'MAP_REQUESTED_SERVICE_SUCCESS';
export const mapRequestedServiceSuccess = ({ storeGuid }) => ({
  type: MAP_REQUESTED_SERVICE_SUCCESS,
  storeGuid,
});
